"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _PreviewJoin = _interopRequireDefault(require("./PreviewJoin"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var PreviewContainer = function PreviewContainer(_ref) {
  var token = _ref.token,
    onJoin = _ref.onJoin,
    env = _ref.env,
    skipPreview = _ref.skipPreview,
    initialName = _ref.initialName;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreviewJoin["default"], {
      initialName: initialName,
      skipPreview: skipPreview,
      env: env,
      onJoin: onJoin,
      token: token
    })
  });
};
var Container = (0, _reactUi.styled)("div", _objectSpread(_objectSpread({
  width: "100%"
}, _reactUi.flexCenter), {}, {
  flexDirection: "column"
}));
var _default = PreviewContainer;
exports["default"] = _default;